import React from 'react';
import PropTypes from 'prop-types';
import BookingTableRowCustomer from './BookingTableRowCustomer';
import BookingTableRowManual from './BookingTableRowManual';


const propTypes = {
    record: PropTypes.object.isRequired,
    handleCancelClick: PropTypes.func.isRequired,
};

const BookingTableRow = props => {
    if (!props.record) return null;

    const isManualBooking = props.record.manual_booking;

    if (isManualBooking) {
        return <BookingTableRowManual {...props} />;
    }

    return <BookingTableRowCustomer {...props} />;
};

BookingTableRow.propTypes = propTypes;

export default BookingTableRow;
